import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useSession } from '../auth/session';
import styles from './Landing.module.css';
import { SiteFooter, SiteHeader } from './SiteChrome';

interface Props {
  title: string;
  updated: string;
  intro: ReactNode;
  children: ReactNode;
}

/** Shared layout for About-style public pages: privacy, guidelines, terms. */
export function PolicyLayout({ title, updated, intro, children }: Props) {
  const { session } = useSession();
  const action = session ? { label: 'Your board', href: '/' } : { label: 'Join', href: '/welcome' };

  return (
    <div className={styles.page}>
      <SiteHeader action={action} />
      <main id="main" className={`${styles.wrap} ${styles.prose}`}>
        <header className={styles.policyHeader}>
          <h1 className={styles.policyTitle}>{title}</h1>
          <p className={styles.policyUpdated}>Last updated {updated}</p>
          <div className={styles.lede}>{intro}</div>
        </header>
        <article className={styles.article}>{children}</article>
        <nav className={styles.policyNav} aria-label="Policies">
          <Link to="/privacy">Privacy</Link>
          <Link to="/guidelines">Community guidelines</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </main>
      <SiteFooter />
    </div>
  );
}
